import PropTypes from 'prop-types';

import CheckboxFilter from '../../OC/oc-filter-list/filters/CheckboxFilter';
// import sealImage from "./seal.png";
// import defendImage from "./defend.png";
// import breatheImage from "./breathe.png";

class RoofingComponentFilter extends CheckboxFilter {
  static propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(slug, wasChecked) {
    const updatedValues = wasChecked ? this.props.selected.filter(v => v !== slug) : [...this.props.selected, slug];
    this.props.onChange(updatedValues);
  }

  render() {
    // TODO: Dynamically set array indices for each application section start
    const applicationStartIndices = [0, 2, 5];
    const sdbImages = {
      seal: '', // sealImage,
      defend: '', // defendImage,
      breathe: '', // breatheImage
    };

    return (
      <ul className={`filterList ${this.props.className}`}>
        {this.props.options.map((a, idx) => (
          <span key={a.slug}>
            {applicationStartIndices.includes(idx) ? <img src={sdbImages[a.applications[0].toLowerCase()]} /> : null}
            <li>
              <label className="boolean optional">
                <input
                  className="boolean optional"
                  type="checkbox"
                  name="category"
                  value={a.slug}
                  checked={this.props.selected.includes(a.slug)}
                  data-track="filter"
                  data-track-filter-name={this.props.title}
                  data-track-filter-option={a.name}
                  onChange={() => this.onChange(a.slug, this.props.selected.includes(a.slug))}
                />{' '}
                {a.name}
              </label>
            </li>
          </span>
        ))}
      </ul>
    );
  }
}

export default RoofingComponentFilter;
